import {
	Checkbox,
	CurrencyInput,
	Input,
	InputValidation,
	Label,
	NumberInput,
	RequiredMarker,
	Text,
} from "@components";
import PricingRecord, { PricingSettings } from "@models/PricingRecord";
import React, { BaseSyntheticEvent } from "react";
import { Col, FormGroup, Row } from "react-bootstrap";
import { Controller, useFormContext } from "react-hook-form";
import { PricingCardProps } from "./IPricingCardProps";
import { useCustomField } from "./useCustomField";
import styled from "styled-components";
import { colors } from "@theme/theming";

export default function FlatFeePerEmployeePackSettings(
	props: PricingCardProps
) {
	const { control } =
		useFormContext<{ pricingSettings: PricingSettings | null }>();
	const { index, pricingSettings } = props;

	const pricingRecord: PricingRecord = pricingSettings[index];

	const flatFeePerEmployeePack = pricingRecord?.flatFeePerEmployeePack;

	const { setFieldChecked, isChecked } = useCustomField<
		PricingRecord["flatFeePerEmployeePack"]
	>(`pricingSettings.${index}.flatFeePerEmployeePack`, {
		amount: 100,
		description: "",
		minNumberOfPacks: 0,
	});

	const error =
		pricingRecord.flatFeePerEmployeePack &&
		pricingRecord.feePerModuleAndEmployee &&
		Object.keys(pricingRecord.feePerModuleAndEmployee).length > 0
			? {
					message:
						"Diese Option ist mit Preis pro Mitarbeiter/Modul nicht kombinierbar",
			  }
			: undefined;

	return (
		<InputValidation error={error}>
			<Controller
				name={`pricingSettings.${index}.flatFeePerEmployeePack`}
				control={control}
				defaultValue={flatFeePerEmployeePack ?? null}
				render={({ field }) => (
					<Checkbox
						value={!!field.value}
						label="Preis pro Lizenzpaket (Bundle)"
						onChange={(e: BaseSyntheticEvent) =>
							setFieldChecked(!!e.target?.checked)
						}
					/>
				)}
				rules={{
					validate: () => !error,
				}}
			/>
			<br />
			{isChecked && (
				<div>
					<FormGroup as={Row}>
						<Label style={{ marginLeft: 24 }} column sm="3">
							Betrag
						</Label>
						<Col sm="5">
							<Controller
								control={control}
								name={`pricingSettings.${index}.flatFeePerEmployeePack.amount`}
								defaultValue={flatFeePerEmployeePack?.amount || 0}
								render={({ field }) => <CurrencyInput {...field} min={0.0} />}
							/>
							<DescriptionText>
								€ pro 10 Mitarbeiter mit irgendeinem Modul
							</DescriptionText>
						</Col>
					</FormGroup>
					<FormGroup as={Row}>
						<Label style={{ marginLeft: 24, marginTop: -12 }} column sm="3">
							Mindestanzahl an Lizenzpaketen
						</Label>
						<Col sm={5}>
							<Controller
								name={`pricingSettings.${index}.flatFeePerEmployeePack.minNumberOfPacks`}
								control={control}
								defaultValue={0}
								render={({ field }) => (
									<NumberInput
										{...field}
										value={field.value ?? 0}
										min={0}
										integer={true}
									/>
								)}
							/>
						</Col>
					</FormGroup>
					<FormGroup as={Row}>
						<Label style={{ marginLeft: 24 }} column sm="3">
							Beschreibung <RequiredMarker />
						</Label>
						<Col sm="5">
							<Controller
								control={control}
								name={`pricingSettings.${index}.flatFeePerEmployeePack.description`}
								defaultValue={flatFeePerEmployeePack?.description || ""}
								rules={{ required: true }}
								render={({ field }) => (
									<Input placeholder="Bitte Beschreibung eingeben" {...field} />
								)}
							/>
						</Col>
					</FormGroup>
					<br />
				</div>
			)}
		</InputValidation>
	);
}

const DescriptionText = styled(Text)`
	font-size: 0.8em;
	color: ${colors.gray.g400};
`;
